import { NodeType } from "@tiptap/pm/model";
const getFragmentContentNodes = (fragment) => {
  if (!fragment || !("content" in fragment) || !Array.isArray(fragment.content)) {
    return [];
  }
  return fragment.content.filter(isItemNode);
};
const isItemNode = (item) => {
  if (!item || typeof item !== "object") {
    return false;
  }
  return "type" in item && item.type instanceof NodeType;
};
export {
  getFragmentContentNodes
};
//# sourceMappingURL=get-fragment-content-nodes.js.map
